import { PriceZoneModelType } from '@teinor/erp/types/company/priceZone'
import { useParams } from 'react-router-dom'
import { MediumModalCreateEdit } from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { getDictionaryStates } from '../../../../../../../../utils/globals/countries'
import useCountryState from '../../../../../../../../utils/hooks/useCountry'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { getDictionaryCountries } from '../../../../../../../../utils/reducers/getters'
import { sortCountries } from '../../../../../../../../utils/globals/sortCountries'

interface ModalCEPriceZoneProps extends ModalEditComponentProps { }

const ModalCEPriceZone: React.FC<ModalCEPriceZoneProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const { country, setCountry } = useCountryState({ defaultCountry: allRowData?.country })
    const { PriceZoneGroupId } = useParams()
    const fields: FormRender<PriceZoneModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'country',
                    label: t('country', 'País'),
                    component: 'CustomSelectWithSearchBar',
                    items: getDictionaryCountries(),
                    sortFunction: sortCountries,
                    required: true,
                    value: allRowData?.country,
                    onChange: (value: string) => setCountry(value)
                },
                {
                    name: 'state',
                    label: t('state', 'Provincia'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: getDictionaryStates(country),
                    required: false,
                    value: allRowData?.state
                },
                {
                    name: 'postal_code',
                    label: t('postalCode', 'Código Postal'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: false
                },
                {
                    name: 'PriceZoneGroupId',
                    component: 'InputHidden',
                    value: PriceZoneGroupId
                }
            ]
        },
    ]

    return (<MediumModalCreateEdit fields={fields} url={'/api/app/product/priceZoneGroup/priceZone/createPriceZone'} translations={{
        title: t('createNewZone', 'Crear nueva zona'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

export default ModalCEPriceZone